export enum RangeScope {
  MONTH = 'month',
  WEEK = 'week'
}
